import { Schema } from "@comparaonline/products-schema";
import dynamic from "next/dynamic";
import React from "react";

import { useProductDetailProps } from "./useProductDetailProps";

interface ModalProps {
  product: Schema.ProductListProduct;
}

const DetailModal = dynamic(
  import("../../../../productDetail/components/DetailModal").then(mod => mod.DetailModal),
  {
    ssr: false
  }
);

export const Modal: React.FC<ModalProps> = ({ product }) => {
  const modalProps = useProductDetailProps(product);
  return <DetailModal {...modalProps} onClickCta={modalProps.onClose} />;
};
